import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import Loader from "../../Components/Loader/Loader";

import { UploadImage, addReplyToSupportRequest, getSupportById } from "../../Actions/actions";
import { useSelector, useDispatch } from "react-redux";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { MdOutlineAddPhotoAlternate, MdOutlineFileDownload } from "react-icons/md";
import { CgAttachment } from "react-icons/cg";
import { IoSend } from "react-icons/io5";
import { IoMdCloudDownload } from "react-icons/io";
import moment from "moment";
export default function SupportRequest() {
  const editorRef = useRef(null);

  const formatDate = (val) => {
    const date = new Date(val);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(" ", "-");
  };
  const location = useLocation();
  const data = location.state || {};
  const { loginData, supportIdData, loader, Privilages } = useSelector(
    (state) => state.userReducer
  );
  const [reply, setReply] = useState({
    message: "",
    attachmentUrl: null,
  });
  const [filename, setfilename] = useState("")
  const [errors, setErrors] = useState({
    message: "",
    attachmentUrl: "",
  });
  const { role } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const getSupportIdData = () => {
    dispatch(getSupportById(loginData?.accessToken, data.supportId));
  };
  const validateForm = (reply) => {
    let newErrors = {};

    if (!reply.message) {
      newErrors.message = "Message is required";
    }
    // if (!reply.attachments) {
    //   newErrors.attachments = "Attachments is required";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };
  const Reset = () => {
    setReply({
      message: "",
      attachmentUrl: null,
    });
    setfilename("");
    if (editorRef.current) {
      editorRef.current.setContents("");
    }
  };
  useEffect(() => {
    getSupportIdData();
  }, []);
  const handleChange = (content) => {
    setErrors({ ...errors, message: '' })
    setReply((prev) => ({ ...prev, message: content }));
  };

  const handleFileChange = (e) => {
    setErrors({ ...errors, attachmentUrl: '' })
    const file = e.target.files[0];
    setfilename(file.name)
    if (file) {
      dispatch(UploadImage(file, '', (data) => {

        setReply((prev) => ({ ...prev, attachmentUrl: data.data.fileUrl }));
      }))

    }
  };
  const sendReply = () => {
    if (validateForm(reply)) {
      dispatch(
        addReplyToSupportRequest(supportIdData?.id, reply, loginData?.accessToken, () => {
          getSupportIdData();
          Reset();
          setfilename("")
          if (editorRef.current) {
            editorRef.current.setContents("");
          }
        })
      );
    }
  };
  const PrivilagesArray = Privilages?.length > 0 ? (Privilages.filter(
    (item) => item.feature === 'Support'
  )) : []
  console.log("id data", supportIdData);
  return (
    <ParentComponent>
      <PrimaryHeader />
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="w-full  flex flex-row justify-between items-center">
            <h2 className="text-xl font-semibold">Request Title</h2>
            <p className="text-sm font-regular">
              {formatDate(supportIdData?.createdAt)}
            </p>
          </div>{" "}
          {/* <div className="bg-white rounded-lg shadow-md p-6 border mt-4 w-[100%]">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <p className="text-sm text-gray-500">
                    {supportIdData?.subject}
                  </p>
                </div>
                <div>
                  <p className="font-semibold text-gray-700">
                    {supportIdData?.issueCategory}
                  </p>
                </div>
              </div>
              <p className="text-gray-700 mb-4">{supportIdData?.message}</p>
              <div className="align-center flex flex-row justify-between ">
                <p className="text-sm text-gray-500">
                </p>
                {supportIdData?.attachments??.length > 0 ?
                  <div onClick={() => {
                    const file = {
                      filePath: supportIdData?.attachments[0]?.filePath,
                    };

                    const link = document.createElement('a');
                    link.href = file.filePath;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }} className="flex">
                    <MdOutlineFileDownload size={24} className="text-gray-500 text-xl cursor-pointer" />
                  </div> : null}
              </div>
            </div> */}
          <div className="flex justify-between mt-5 px-2">
            <p className="text-gray-800 w-[90%] text-sm px-2 py-1 rounded-lg font-semibold">{supportIdData?.message}</p>
            {supportIdData?.attachments?.length > 0 ?
              <div onClick={() => {
                const file = {
                  filePath: supportIdData?.attachments[0]?.filePath,
                };

                const link = document.createElement('a');
                link.href = file.filePath;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }} className="flex flex-row items-center gap-1 cursor-pointer bg-gray-300 px-2 py-1  rounded-lg"
              >
                <MdOutlineFileDownload size={24} className="text-gray-800 text-xl cursor-pointer" />
                <p className="text-gray-800 font-bold text-xs">Download</p>
              </div> : null}
          </div>
          <div className="p-4">
            {supportIdData?.replies?.map((item) => (
              <div className={item?.createdBy?.email == supportIdData?.createdBy?.email ? "w-[75%]  flex flex-col mt-6 items-start" : "place-self-end w-[75%] flex flex-col mt-6 items-end"}>
                <p className="text-gray-400 text-xs text-right mb-1 flex">
                  {moment(item?.createdAt).format("DD/MM/yy h:mm:A")}
                  <p className="ml-1 text-gray-800 text-xs font-semibold text-right mb-1">
                    {item?.createdBy?.email == supportIdData?.createdBy?.email ? '' : `You`}
                  </p>
                </p>
                <div dangerouslySetInnerHTML={{ __html: item?.message }} className={item?.createdBy?.email == supportIdData?.createdBy?.email ? "bg-gray-50 max-w-[40%] p-2 shadow-sm rounded-lg text-gray-800 text-sm" : 'bg-gray-200 max-w-[40%] p-2 rounded-lg text-gray-800 text-sm'} />
                {item?.attachments?.length > 0 ? (

                  <div
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = item?.attachments[0]?.filePath;
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                    className="flex flex-row items-center gap-1 mt-1  cursor-pointer bg-gray-100 px-2 py-1  rounded-lg"
                  >
                    <MdOutlineFileDownload className=" text-gray-800 text-lg" />
                    <p className="text-gray-800 font-bold text-xs">Download</p>
                  </div>
                ) : null}



              </div>
            ))}
          </div>
          {/* /// */}
          {/* <div className="w-full justify-self-end">
              {supportIdData?.replies?.map((reply) => (
                <div
                  key={reply?.id}
                  className={reply?.createdBy?.email == supportIdData?.createdBy?.email ? "bg-white w-[75%] rounded-lg shadow-md p-6 border sm:mt-4" : 'bg-gray-100 w-[75%] place-self-end rounded-lg shadow-md p-6 border sm:mt-4'}
                >
                  <div className="flex justify-between items-start mb-4">
                    <p className="text-lg font-semibold text-gray-700">{reply?.createdBy?.email == supportIdData?.createdBy?.email ? '' : 'Reply'}</p>
                    <p className="text-sm text-gray-500">
                      {formatDate(reply?.createdAt)}
                    </p>
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: reply?.message }} />
                  <div className="align-center flex flex-row justify-between">
                    <p className="text-sm text-gray-500">
                    </p>
                    {reply?.attachments??.length > 0 ?
                      <div onClick={() => {
                        const link = document.createElement('a');
                        link.href = reply?.attachments[0]?.filePath
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }} className="flex">
                        <MdOutlineFileDownload size={24} className="text-gray-500 text-xl cursor-pointer" />
                      </div>
                      : null}
                  </div>
                </div>
              ))}
            </div> */}
          {PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel == 'Full Access' ?
            (<div className="bg-white rounded-lg shadow-md p-6 border mt-4">
              <SunEditor
                getSunEditorInstance={(sunEditor) => (editorRef.current = sunEditor)}
                setOptions={{
                  height: 300,
                  buttonList: [
                    ["font", "bold", "italic", "underline"],
                    ["align", "list", "paragraphStyle"],
                    ["link", "image", "video", "removeFormat"],
                  ],
                  placeholder: "Write something awesome...",
                }}
                value={reply.message}
                onChange={handleChange}
              />
              {errors.message !== '' && (
                <p className="text-red-500 text-sm mt-1">{errors.message}</p>
              )}
            </div>) : null) : (<div className="bg-white rounded-lg shadow-md p-6 border mt-4">
              <SunEditor
                getSunEditorInstance={(sunEditor) => (editorRef.current = sunEditor)}
                setOptions={{
                  height: 300,
                  buttonList: [
                    ["font", "bold", "italic", "underline"],
                    ["align", "list", "paragraphStyle"],
                    ["link", "image", "video", "removeFormat"],
                  ],
                  placeholder: "Write something awesome...",
                }}
                value={reply.message}
                onChange={handleChange}
              />
              {errors.message !== '' && (
                <p className="text-red-500 text-sm mt-1">{errors.message}</p>
              )}
            </div>)}
          {PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel == 'Full Access' ?
            (
              <div className="p-4 flex flex-row items-center justify-between">
                <div className="flex flex-row gap-2 items-center">
                  {reply.attachmentUrl && (
                    <span className="text-sm text-gray-700">
                      {reply.attachmentUrl.name}
                    </span>
                  )}
                  <label htmlFor="image-upload">
                    <MdOutlineAddPhotoAlternate className="text-gray-600 text-xl cursor-pointer hover:text-gray-800" />
                  </label>
                  <input
                    type="file"
                    id="image-upload"
                    className="hidden"
                    accept="image/*"
                    onChange={handleFileChange}
                  />

                  <label htmlFor="file-upload">
                    <CgAttachment className="text-gray-600 text-lg cursor-pointer hover:text-gray-800" />
                  </label>
                  <input
                    type="file"
                    id="file-upload"
                    className="hidden"
                    onChange={handleFileChange}
                  />{" "}
                  {errors.attachmentUrl !== '' && (
                    <p className="text-red-500 text-sm mt-1">{errors.attachmentUrl}</p>
                  )}
                  {filename !== '' && (
                    <p className="text-black text-sm mt-1">{filename}</p>
                  )}
                </div>
                <div className="flex flex-row items-center gap-1 bg-primary py-2 px-2 rounded-lg cursor-pointer hover:bg-blue-600">
                  <p className="text-sm font-bold text-white px-2" onClick={sendReply}>
                    Send
                  </p>
                  <IoSend className=" text-white text-md" />
                </div>
              </div>) : null) : (

            <div className="p-4 flex flex-row items-center justify-between">
              <div className="flex flex-row gap-2 items-center">
                {reply.attachmentUrl && (
                  <span className="text-sm text-gray-700">
                    {reply.attachmentUrl.name}
                  </span>
                )}
                <label htmlFor="image-upload">
                  <MdOutlineAddPhotoAlternate className="text-gray-600 text-xl cursor-pointer hover:text-gray-800" />
                </label>
                <input
                  type="file"
                  id="image-upload"
                  className="hidden"
                  accept="image/*"
                  onChange={handleFileChange}
                />

                <label htmlFor="file-upload">
                  <CgAttachment className="text-gray-600 text-lg cursor-pointer hover:text-gray-800" />
                </label>
                <input
                  type="file"
                  id="file-upload"
                  className="hidden"
                  onChange={handleFileChange}
                />{" "}
                {errors.attachmentUrl !== '' && (
                  <p className="text-red-500 text-sm mt-1">{errors.attachmentUrl}</p>
                )}
                {filename !== '' && (
                  <p className="text-black text-sm mt-1">{filename}</p>
                )}
              </div>
              <div className="flex flex-row items-center gap-1 bg-primary py-2 px-2 rounded-lg cursor-pointer hover:bg-blue-600">
                <p className="text-sm font-bold text-white px-2" onClick={sendReply}>
                  Send
                </p>
                <IoSend className=" text-white text-md" />
              </div>
            </div>
          )}
        </>
      )}
    </ParentComponent>
  );
}